import { useRef } from 'react';
import type React from 'react';

import type { Body, Meta, Uppy } from '@uppy/core';

import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { CustomFileInput } from './CustomFileInput';

type Props = {
	uppy: Uppy<Meta, Body>;
	fileInputId: string;
	onButtonClick?: () => void;
	uploadButtonText?: string;
	buttonTheme?: 'gray';
	buttonSize?: 'small';
};

export const AccessibleFileInputWrapper: React.FC<Props> = ({
	uppy,
	fileInputId,
	onButtonClick,
	uploadButtonText = 'Upload',
	buttonTheme,
	buttonSize,
}) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const isGray = buttonTheme === 'gray';

	return (
		<>
			<CustomFileInput inputFileRef={inputRef} onButtonClick={onButtonClick} fileInputId={fileInputId} uppy={uppy} />
			<button
				type="button"
				onClick={() => inputRef.current?.click()}
				// border grows 1px->2px on interaction; padding shrinks 1px to keep the box the same size
				className={cn(
					'flex h-11 cursor-pointer flex-col items-center justify-center rounded-lg border border-solid px-[23px] py-[9px] font-bold hover:border-2 hover:px-[22px] hover:py-2 focus:border-2 focus:px-[22px] focus:py-2 active:border-2 active:px-[22px] active:py-2',
					isGray
						? 'border-[#707070] text-black hover:border-black focus:border-black active:border-black'
						: 'border-[#E01A2B] text-[#E01A2B]',
				)}
			>
				<Text as="span" fontWeight="bold" size={buttonSize === 'small' ? 'medium' : 'large'}>
					{uploadButtonText}
				</Text>
			</button>
		</>
	);
};
